export default __webpack_public_path__ + "static/media/lockIcon.08417af5.svg";